<template>
  <!-- 新增试卷弹窗 -->
  <div v-if="visible" class="dialog-overlay" @click="handleClose">
    <div class="dialog-content" @click.stop>
      <div class="dialog-header">
        <h3>新增{{ testType }}试卷</h3>
        <button class="close-btn" @click="handleClose">×</button>
      </div>
      <div class="dialog-body">
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label>所属考试</label>
            <div class="readonly-field">{{ testName }}</div>
          </div>
          <div class="form-group">
            <label>试卷总题数</label>
            <input
              type="number"
              v-model="formData.totalScore"
              placeholder="请输入试卷总题数，如：40"
              required
              min="1"
            />
          </div>
          <div class="form-group">
            <label>试卷类型</label>
            <input
              type="text"
              v-model="formData.paperType"
              placeholder="请输入试卷类型，如：日常生活、短篇新闻"
              required
            />
          </div>
          <div class="form-group">
            <label>起始题号</label>
            <input
              type="number"
              v-model="formData.setOff"
              placeholder="请输入起始题号，如：1"
              required
              min="1"
            />
          </div>
          <div class="form-group">
            <label>Section/Part</label>
            <input
              type="number"
              v-model="formData.paperIndex"
              placeholder="请输入试卷次序，如：SectionA 填写1"
              required
              min="1"
            />
          </div>
        </form>
      </div>
      <div class="dialog-footer">
        <button type="button" class="cancel-btn" @click="handleClose">
          取消
        </button>
        <button type="button" class="confirm-btn" @click="handleSubmit">
          确认
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddPaperDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    testName: {
      type: String,
      default: "",
    },
    testId: {
      type: Number,
      default: null,
    },
    testType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formData: {
        totalScore: "",
        paperType: "",
        setOff: "",
        paperIndex: "",
      },
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    resetForm() {
      this.formData = {
        totalScore: "",
        paperType: "",
        setOff: "",
        paperIndex: "",
      };
    },
    handleSubmit() {
      // 验证表单
      if (
        !this.formData.totalScore ||
        !this.formData.paperType ||
        !this.formData.setOff ||
        !this.formData.paperIndex
      ) {
        this.$message.error("请填写所有必填字段");
        return;
      }
      this.formData.setOff = this.formData.setOff - 1;
      // 发送数据到父组件，包含隐藏的testId
      this.$emit("submit", {
        ...this.formData,
        testId: this.testId,
      });
    },
  },
};
</script>

<style scoped>
/* 弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  border-radius: 12px 12px 0 0;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #333;
}

.dialog-body {
  padding: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #ffd700;
  box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
}

.form-group input::placeholder {
  color: #999;
}

.readonly-field {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  background-color: #f5f5f5;
  color: #666;
  box-sizing: border-box;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.cancel-btn,
.confirm-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
}

.cancel-btn:hover {
  background: #e8e8e8;
}

.confirm-btn {
  background: #ffd700;
  color: #2c3e50;
}

.confirm-btn:hover {
  background: #e6c200;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .dialog-content {
    width: 95%;
    margin: 20px;
  }

  .dialog-header,
  .dialog-body,
  .dialog-footer {
    padding: 16px;
  }

  .dialog-footer {
    flex-direction: column;
  }
}
</style>
